import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { Driver, Order } from '../types/fleet';
import { drivers as initialDrivers } from '../data/drivers';
import { initialOrders } from '../data/orders';
interface FleetContextValue {
  drivers: Driver[];
  orders: Order[];
  assignDriver: (orderId: string, driverId: string) => void;
  addOrder: (order: Omit<Order, 'id' | 'status' | 'createdAt'>) => Order;
}
const FleetContext = createContext<FleetContextValue | null>(null);
export function FleetProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [drivers, setDrivers] = useState<Driver[]>(initialDrivers);
  const [orders, setOrders] = useState<Order[]>(initialOrders);
  const assignDriver = useCallback((orderId: string, driverId: string) => {
    setOrders(prev => prev.map(o => o.id === orderId ? {
      ...o,
      status: 'assigned',
      driverId
    } : o));
    setDrivers(prev => prev.map(d => d.id === driverId ? {
      ...d,
      status: 'busy'
    } : d));
  }, []);
  const addOrder = useCallback((data: Omit<Order, 'id' | 'status' | 'createdAt'>) => {
    const order: Order = {
      ...data,
      id: `№ ${10483 + Math.floor(Math.random() * 400)}`,
      status: 'new',
      createdAt: new Date().toLocaleTimeString('ru-RU', {
        hour: '2-digit',
        minute: '2-digit'
      })
    };
    setOrders(prev => [order, ...prev]);
    return order;
  }, []);
  const value = useMemo(() => ({
    drivers,
    orders,
    assignDriver,
    addOrder
  }), [drivers, orders, assignDriver, addOrder]);
  return <FleetContext.Provider value={value} data-id="element-156" data-mp="2q6brk4f02mr3">{children}</FleetContext.Provider>;
}
export function useFleet(): FleetContextValue {
  const ctx = useContext(FleetContext);
  if (!ctx) throw new Error('useFleet должен использоваться внутри FleetProvider');
  return ctx;
}